module.exports = __webpack_public_path__ + "static/media/right-elements-fisk.b4c46576.svg";